import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import Localization from "../../localization";
import IconLogo from "../icons/logo";
import IconBurguer from "../icons/burguer";
import IconCalendar from "../icons/calendar";
import IconLib from "../icons/lib";
import Button from "../button";

import { getMe } from "../../redux/selectors/me";
import {
    changeMobileMenu,
    changeLogin,
    changeSearch,
} from "../../redux/actions/options";
import { getUrl } from "../../utils/helper";
import { appLocales } from "../../localization";
import IconLogin from "../icons/login";
import IconSearch from "../icons/search";

class MobileMenu extends Component {
    constructor(props) {
        super(props);

        this._hideMenu = this._hideMenu.bind(this);
    }

    _hideMenu() {
        this.props.changeMobileMenu(false);
    }

    _onLoginPress() {
        this._hideMenu();
        this.props.changeLogin(true);
    }

    _onSearchPress = () => {
        this._hideMenu();
        this.props.changeSearch(true);
    }

    _renderButton(text, url, onClick, icon) {
        const { pathname } = this.props;

        let color = "blue";

        const backgroundColor = "bg-" + color;
        const borderColor = "border-" + color;

        let isActive = false;
        if (url) {
            isActive = pathname.split("/")[2] === url.split("/")[2];
        }

        return (
            <Button
                icon={icon}
                text={text}
                backgroundColor={isActive ? backgroundColor : "bg-transparent"}
                backgroundColorOver={backgroundColor}
                to={url}
                onClick={onClick}
                borderColor={borderColor}
                textStyle={
                    isActive
                        ? "font-bold text-20 z-10 transition hover-hover:group-hover:text-white text-white"
                        : "font-bold text-20 z-10 transition hover-hover:group-hover:text-white text-" +
                          color
                }
                wrapperStyle="px-15"
            />
        );
    }

    render() {
        const { visible, pathname, locale, user } = this.props;

        let className =
            "xl:hidden fixed z-40 inset-0 overflow-y-auto transition duration-300 ease-in-out";
        if (!visible) {
            className += " pointer-events-none opacity-0";
        }

        let color = "blue";
        className += " bg-pink";

        const textStyle =
            "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-" +
            color;
        const iconStyle =
            "w-25 h-25 z-10 transition hover-hover:group-hover:text-white text-" +
            color;
        const backgroundColor = "bg-" + color;
        const borderColor = "border-" + color;

        return (
            <div className={className}>
                <Helmet>{visible && <body className="modal-open" />}</Helmet>
                <div className="px-16 pt-30 pb-20 overflow-y-auto w-full">
                    <div className="flex justify-between mb-30">
                        <Link
                            to={getUrl("/")}
                            onClick={this._hideMenu}
                            className="flex flex-col"
                            title={"PAULO CUNHA E SILVA"}
                        >
                            <IconLogo
                                className={"w-140 h-30 -ml-2 text-" + color}
                            />
                            <p
                                className={
                                    "font-judge font-bold mt-5 text-12 text-" +
                                    color
                                }
                            >
                                PAULO CUNHA E SILVA
                            </p>
                        </Link>
                        <Button
                            icon={
                                <IconBurguer
                                    opened={visible}
                                    color={backgroundColor}
                                />
                            }
                            backgroundColorOver={backgroundColor}
                            onClick={this._hideMenu}
                            borderColor={borderColor}
                            style={"w-50"}
                        />
                    </div>
                    <div className="flex justify-between mb-12">
                        {this._renderButton(
                            Localization[locale].navigation.info,
                            getUrl("about"),
                            this._hideMenu
                        )}
                        <Button
                            icon={<IconLogin className={iconStyle} />}
                            backgroundColorOver={backgroundColor}
                            to={user ? getUrl("account/profile") : null}
                            onClick={() => {
                                if (!user) {
                                    this._onLoginPress();
                                }
                                this._hideMenu();
                            }}
                            borderColor={borderColor}
                            style={"w-50"}
                        />
                    </div>
                    <div className="flex justify-between mb-12">
                        {this._renderButton(
                            Localization[locale].navigation.open_calls,
                            getUrl("opencalls"),
                            this._hideMenu
                        )}
                        <Button
                            icon={<IconSearch className={iconStyle} />}
                            backgroundColorOver={backgroundColor}
                            onClick={this._onSearchPress}
                            borderColor={borderColor}
                            style={"w-50"}
                        />
                        {/* 
                        <Button
                            icon={<IconCalendar className={iconStyle} />}
                            backgroundColorOver={backgroundColor}
                            to={getUrl("/calendar")}
                            onClick={this._hideMenu}
                            borderColor={borderColor}
                            style={"w-50"}
                        />
                        */}
                    </div>
                    <div className="flex justify-between mb-12">
                        {this._renderButton(
                            Localization[locale].navigation.spaces,
                            getUrl("spaces_booking"),
                            this._hideMenu
                        )}
                    </div>
                    <div className="flex justify-between mb-12">
                        {this._renderButton(
                            Localization[locale].navigation.classes,
                            getUrl("practices"),
                            this._hideMenu
                        )}
                    </div>
                    <div className="flex justify-between mb-12">
                        {this._renderButton(
                            Localization[locale].navigation.blog,
                            getUrl("bookmarks"),
                            this._hideMenu
                        )}
                    </div>
                    <div className="flex justify-between mb-12">
                        {this._renderButton(
                            Localization[locale].navigation.artists,
                            getUrl("artists"),
                            this._hideMenu
                        )}
                    </div>
                    <div className="flex mb-12">
                        <Button
                            text={appLocales[0].toUpperCase()}
                            backgroundColor={
                                locale === appLocales[0] && "bg-" + color
                            }
                            backgroundColorOver={backgroundColor}
                            onClick={() => {
                                let url = window.location.href.replace(
                                    "/" + this.props.locale,
                                    "/" + appLocales[0]
                                );

                                window.location.replace(url);
                                this._hideMenu();
                            }}
                            borderColor={borderColor}
                            textStyle={
                                locale === appLocales[0]
                                    ? "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-white"
                                    : "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-" +
                                      color
                            }
                            wrapperStyle={"px-15"}
                        />
                        <Button
                            text={appLocales[1].toUpperCase()}
                            backgroundColor={
                                locale === appLocales[1] && "bg-" + color
                            }
                            backgroundColorOver={backgroundColor}
                            onClick={() => {
                                let url = window.location.href.replace(
                                    "/" + this.props.locale,
                                    "/" + appLocales[1]
                                );

                                window.location.replace(url);
                                this._hideMenu();
                            }}
                            borderColor={borderColor}
                            textStyle={
                                locale === appLocales[1]
                                    ? "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-white"
                                    : "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-" +
                                      color
                            }
                            style={"ml-12"}
                            wrapperStyle="px-15"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    user: getMe(state),
    visible: state.options.isMobileMenuVisible,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            changeLogin,
            changeSearch,
            changeMobileMenu,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileMenu);
